<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="text-center">
            
            <b-button size="sm" variant="primary" class="mr-3" @click="$router.push({ name: 'requirements.add.new' })">
              <i class="fa fa-plus"></i>
              Add Requirement
            </b-button>
          

            <b-button v-if="checkClaim(CAN_ADD_OFFERS)" size="sm" variant="primary" @click="$bvModal.show('global-offer-modal')" class="mr-3">
              <i class="fa fa-plus"></i>
              New Offer
            </b-button>

            <b-button size="sm" @click="openTodoModal" variant="primary" class="mr-3">
              <i class="fa fa-plus"></i>
              New Task
            </b-button>  

            <add-quote v-if="checkClaim(CAN_ACCESS_QUOTES)" />

            <add-sales-order v-if="checkClaim(CAN_ADD_SALES_ORDER)" />

            <add-purchase-order v-if="checkClaim(CAN_ADD_POS)" />

            <add-crma v-if="checkClaim(CAN_ADD_RMAS)" :modalId="'toolbar-crma-modal'" class="mr-2" />

            <add-vrma v-if="checkClaim(CAN_ADD_VENDOR_RETURNS)" class="mr-2" />

            <add-offer v-if="checkClaim(CAN_ADD_OFFERS)" :modalId="'global-offer-modal'"/>
            
            
            <add-task :editDetails="taskDetails" modalId="toolbar-add-task" />

        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="9">
        <b-row>
          <b-col>
            <shipping-and-receiving-tracking-widget />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <sales-and-expense-widget />
            <!-- <sales-person-widget /> -->
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col cols="6">
            <sales-person-metrics-widget />
          </b-col>
          <b-col cols="6">
            <sales-person-req-to-s-o-conversion-widget />
          </b-col>
        </b-row> -->
        <b-row>
          <b-col>
            <sales-person-req-to-s-o-conversion-widget />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <req-quot-so-chart-widget />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <requirement-statuses-widget />
          </b-col>
          <b-col cols="4">
            <quote-statuses-widget />
          </b-col>
          <b-col cols="4">
            <sales-order-statuses-widget />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3">
        <company-tasks />
      </b-col>
    </b-row>
    
   </div>
</template>

<script>
import { mapActions } from 'vuex';
import SalesAndExpenseWidget from './widgets/SalesAndExpense';
import SalesPersonMetricsWidget from './widgets/SalesPersonMetrics';
import SalesPersonReqToSOConversionWidget from './widgets/SalesPersonReqToSOConversion';
import ReqQuotSoChartWidget from './widgets/ReqQuotSOCharts';
import SalesPersonWidget from './widgets/SalesPersonWidget';
import QuoteStatusesWidget from './widgets/QuoteStatuses';
import RequirementStatusesWidget from './widgets/RequirementStatuses';
import SalesOrderStatusesWidget from './widgets/SalesOrderStatuses';
import CompanyTasks from './widgets/CompanyTaskWidget';
import ExpensesWidget from './widgets/ExpensesWidget';
import InvoicesWidget from './widgets/InvoicesPaidUnpaid';
import AddQuote from '@/pages/Quotes/components/AddQuote/index';
import AddSalesOrder from '@/pages/SalesOrders/components/add/index';
import AddPurchaseOrder from '@/pages/PurchaseOrders/components/add/index';
import AddInvoice from '@/pages/Invoices/components/add/index';
import AddCrma from '@/pages/Customerrmas/components/add/index';
import AddVrma from '@/pages/Vendorrmas/components/add/index';
import AddOffer from '@/shared/components/Offers/components/AddOffer';
import AddTask from '@/pages/Todotasks/components/add';
import ShippingAndReceivingTrackingWidget from './widgets/ShippingAndReceivingTrackWidget';

export default {
  components: {
    SalesAndExpenseWidget,
    SalesPersonMetricsWidget,
    SalesPersonReqToSOConversionWidget,
    ReqQuotSoChartWidget,
    SalesPersonWidget,
    QuoteStatusesWidget,
    RequirementStatusesWidget,
    SalesOrderStatusesWidget,
    CompanyTasks,
    ExpensesWidget,
    InvoicesWidget,
    AddQuote,
    AddSalesOrder,
    AddPurchaseOrder,
    AddInvoice,
    AddCrma,
    AddVrma,
    AddOffer,
    AddTask,
    ShippingAndReceivingTrackingWidget
  },  
  metaInfo: () => ({
    title: 'Dashboard',
  }),
  data() {
    return {
      taskDetails: {}
    }
  },
  methods: {
    ...mapActions('salesReps', ['getSalesReps']),
    showAddQuoteModal() {
      this.$refs['add-quote-modal'].show();
    },
    openTodoModal() {
      this.taskDetails = {};

      this.$bvModal.show('toolbar-add-task');
    },
  },
  mounted() {
    this.getSalesReps();
  }
}
  
</script>

<style>
</style>